import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';

export default class Rivette extends AContainer {
  constructor(scene, startX, startY, type) {
    super(scene);

    this.skins = ['content', 'happy', 'worried', 'concerned'];
    this.animations = ["blink", 'idle', 'scratchBack', "flexWrench", "right", "medium", "wrong", 'walk'];
    this.blendTime = 300;

    this.character = this.scene.addSpine(startX, startY, 'rivette', "walk", true, (obj) => { this.completeCheck(obj); });

    this.setInitParams();

    if (type === "intro" || type === "museum") this.character.spine.setScale(-.75, .75);
  }

  setInitParams() {
    this.character.setSkin(this.skins[0]);

    //play blinking animation
    this.character.playTrack(this.animations[0], true, 1);
  }

  completeCheck(obj) {
    if (this.isBlending === false) {
      if (obj.animation !== null && obj.animation.name !== "blink" && obj.animation.name !== "walk") this.animComplete(obj);
    } else {
      return;
    }
  }

  dialogue() {
    this.speechBub = this.scene.add.container();

    let txt;
    let size;
    if (gameData.artifacts.length === 0) {
      size = 18;
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('dialogue_complete');
    } else {
      size = 22;
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('dialogue_playAgain');
    }
    const text = ABCyaPhaser.Text.addText(-110, -125, size, 0x5e3423, FontKeys._Tertre_Med, txt, this.speechBub, false).setWordWrapWidth(225).setOrigin(0, 0.5);
    ABCyaPhaser.Text.resizeFontToFitWidth(text, 225, 50, size);
    const speech = this.scene.addImage(0, 0, 'PlayAgainSpeechBubble', ABCyaPhaser.Images.DEFAULT_ATLAS, this.speechBub).setOrigin(0.585714, 0.975309);
    this.speechBub.moveBelow(speech, text);

    this.btn = this.scene.addImage(-155, -125, "PlayAgainBtn", this.scene.defaultAtlas, this.speechBub);
    this.speechBub.setPosition(900, 313);
    this.speechBub.setScale(0, 0);

    this.scene.addTween(this.speechBub, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
      () => { this.enableBtn(); });
  }

  dialogueWords(complete) {
    this.speechBub = this.scene.add.container();
    let speech = this.scene.addImage(0, 0, "InstruxPopup1", this.scene.defaultAtlas, this.speechBub);
    this.speechBub.setPosition(160, 370);
    speech.setScale(.5, .4);
    this.speechBub.setScale(0, 0);
    this.speechBub.setDepth(4);

    let past = gameData.combined[0].past.toLocaleUpperCase();
    let present = gameData.combined[0].present.toLocaleUpperCase();
    let txt;
    if (!complete) {
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('dialogue_incorrect').replace('~', present).replace('@', past);
    } else {
      txt = gameData.dialogue_correct;
    }

    const text = ABCyaPhaser.Text.addText(-60, -120, 24, 0x5e3423, FontKeys._Tertre_Med, txt, this.speechBub, false).setWordWrapWidth(280);//.setShadow(1, 1, '#222');

    this.scene.addTween(this.speechBub, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);

    this.scene.addDelay(3500, () => { this.clearDialogueWords(complete); });
  }

  clearDialogueWords(complete) {
    this.scene.addTween(this.speechBub, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In,
      () => {
        if (complete) {
          this.scene.smallPortal.emptyArtifact();
        }
        this.speechBub.destroy();
      });
  }

  clearDialogue() {
    this.disableBtn();

    this.scene.addTween(this.speechBub, 250, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
  }

  enableBtn() {
    this.btn.setInteractive();

    this.btn.on('pointerup', () => { this.scene.tweenOutMuseum(); });
  }

  disableBtn() {
    this.btn.disableInteractive();
  }

  playAnimation(animation, loop = false) {
    //change the face to match the emotion
    if (animation === "idle" || animation === "flexWrench") {
      this.character.setSkin(this.skins[0]);
      this.character.play(animation, loop);
    }
    else if (animation === "right") {
      this.isBlending = true;
      this.scene.addDelay(this.blendTime, () => { this.isBlending = false; });

      this.character.setSkin(this.skins[1]);
      this.character.play(animation, loop);
    }
    else if (animation === "wrong") {
      this.isBlending = true;
      this.scene.addDelay(this.blendTime, () => { this.isBlending = false; });

      this.character.setSkin(this.skins[2]);
      this.character.play(animation, loop);
    }
    else if (animation === "medium") {
      this.isBlending = true;
      this.scene.addDelay(this.blendTime, () => { this.isBlending = false; });

      this.character.setSkin(this.skins[2]);
      this.character.play(animation, loop);
    }
    else if (animation === "scratchBack") {
      this.character.setSkin(this.skins[3]);
      this.character.play(animation, loop);
    }
    else if (animation === "walk") {
      this.isBlending = true;
      this.scene.playSound("footsteps");
      this.scene.addDelay(this.blendTime, () => { this.isBlending = false; });

      this.character.play(animation, loop);
    }
  }

  animComplete(obj) {
    let randAnim = Phaser.Math.Between(1, 10);

    if (randAnim === 1) {
      this.playAnimation(this.animations[2]);
    }
    else if (randAnim === 2) {
      this.playAnimation(this.animations[3]);
    }
    else {
      this.playAnimation(this.animations[1]);
    }
  }

  cleanUp() {
    if (this.character.spine.state) this.character.spine.state.clearListeners();
    this.skins = [];
    this.animations = [];
    this.character.spine.destroy();

    if (this.btn) {
      this.disableBtn();
    }

    if (this.speechBub) {
      this.speechBub.destroy();
    }
  }
}